import { Box, Text, useColorModeValue } from '@chakra-ui/react';
import { formatFullNumber, formatShare } from '../../utils/format';

// Single categorical palette for all pie/donut/bar charts across the app.
// Superset of the old per-page arrays (PIE_COLORS / COLORS / CHART_COLORS).
export const CHART_PALETTE = ['#6366F1', '#EC4899', '#10B981', '#F59E0B', '#06B6D4', '#8B5CF6', '#EF4444', '#14B8A6'];

// One source of truth for theme-aware chart surface colors (tooltips, axes, grid).
export const useChartColors = () => ({
  tooltipBg: useColorModeValue('#FFFFFF', '#1A202C'),
  tooltipText: useColorModeValue('#1A202C', '#E2E8F0'),
  gridColor: useColorModeValue('#E2E8F0', '#2D3748'),
  axisTextColor: useColorModeValue('#718096', '#A0AEC0'),
});

// Shared tooltip for pie/donut charts: a colored "name : value (pct%)" line on a
// theme-aware surface, matching the line chart (Traffic Over Time) tooltip. The slice
// color falls back to the text color so it is never unreadable (e.g. dark-on-dark).
export const ChartPieTooltip = ({ active, payload }) => {
  const { tooltipBg, tooltipText, gridColor } = useChartColors();
  if (!active || !payload || !payload.length) return null;
  const item = payload[0];
  const data = item.payload || {};
  const sliceColor = data.fill || item.color || tooltipText;
  const pct = data.percentage != null ? ` (${formatShare(data.percentage, data.value)})` : '';
  return (
    <Box bg={tooltipBg} border="1px solid" borderColor={gridColor} borderRadius="8px" px={2.5} py={1.5} sx={{ whiteSpace: 'nowrap' }}>
      <Text fontSize="14px" color={sliceColor}>
        {`${data.name} : ${formatFullNumber(data.value)}${pct}`}
      </Text>
    </Box>
  );
};
